/* Skeleton.tsx generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Skeleton } from '@atlassian/mpac-primitives';
import React from 'react';
import { TEST_IDS } from './testIds';
const _6 = "._4t3i124j{height:324px}";
const _5 = "._4t3intd2{height:184px}";
const _4 = "._4t3imhvn{height:148px}";
const _3 = "._p12f1lk4{max-width:520px}";
const _2 = "._2rko1q77{border-radius:var(--ds-border-radius-400,1pc)}";
export const AppTileSize = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
export const AppTileSkeleton = forwardRef((_ref, __cmplr) => {
  let {
      as: C = Skeleton,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2, _3, _4, _5, _6]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_2rko1q77 _p12f1lk4", __cmplp.size === AppTileSize.SMALL ? "_4t3imhvn" : __cmplp.size === AppTileSize.MEDIUM ? "_4t3intd2" : "_4t3i124j", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  AppTileSkeleton.displayName = 'AppTileSkeleton';
}
export const AppTileGridSkeleton = _ref2 => {
  let {
    tileCount = 6,
    size = AppTileSize.LARGE
  } = _ref2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, Array.from({
    length: tileCount
  }, (_, index) => /*#__PURE__*/React.createElement(AppTileSkeleton, {
    "data-testid": TEST_IDS.APP_TILE_SKELETON,
    key: index,
    size: size
  })));
};